import { CodeArticleState } from '@livv/models';

type StatusDateManagement = Record<
    CodeArticleState,
    { fullDescription: string; isDateDebutValid: boolean; isDateFinValid: boolean }
>;

/**
 * Used to find check which dates are valide and display correspondingly
 * ANNULE and MODIFIE_MORT_NE have isDateDebutValid and isDateFinValid set to false,
 * code articles with these statuses are not displayed in the timeline
 */
export const STATUS_DATE_MANAGEMENT: Omit<StatusDateManagement, 'ANNULE' | 'MODIFIE_MORT_NE'> = {
    ABROGE: {
        fullDescription:
            "Abrogé, cas d'un article qui n'est plus en vigueur par suite d'une abrogation explicite par un texte publié au Journal officiel.",
        isDateDebutValid: true,
        isDateFinValid: true,
    },
    ABROGE_DIFF: {
        fullDescription:
            "Vigueur avec terme, désigné également par abrogé différé : cas d'un article en vigueur à la date courante, mais sa fin de vigueur est déjà prévue à une date connue et précisée, il passera à son nouveau statut (modifié ou abrogé).",
        isDateDebutValid: true,
        isDateFinValid: true,
    },
    DISJOINT: {
        fullDescription:
            "Disjoint, cas d'un article « séparé » du code ; ses dispositions ne sont plus appliquées. Cette disjonction peut ne pas être définitive ; ses dispositions peuvent être rétablies par un nouveau texte. Cet état juridique est spécifique à la législation fiscale. Ne doit pas présent dans les codes sur Livv",
        isDateDebutValid: true,
        isDateFinValid: true,
    },
    MODIFIE: {
        fullDescription:
            "Modifié, cas d'un article faisant l'objet d'une modification, ponctuation, remplacement ou suppression d'un mot, groupe de mots ou de tout le contenu qui entraîne la création d'une version dite « modifiée »",
        isDateDebutValid: true,
        isDateFinValid: false,
    },
    PERIME: {
        fullDescription:
            "Périmé, cas d'un article faisant l'objet d'une abrogation implicite ; c'est le cas, par exemple, de l'article 39 octies du code général des impôts.",
        isDateDebutValid: true,
        isDateFinValid: false,
    },
    TRANSFERE: {
        fullDescription:
            "Transféré, cas d'un article dont les dispositions sont reprises sous un autre numéro d'article.",
        isDateDebutValid: true,
        isDateFinValid: true,
    },
    VIGUEUR: {
        fullDescription: "Vigueur, cas d'un article qui s'applique à la date courante.",
        isDateDebutValid: true,
        isDateFinValid: false,
    },
    VIGUEUR_DIFF: {
        fullDescription:
            "Vigueur différée, cas d'un article qui entre en vigueur à une date ultérieure. Lorsque cette date est connue, cet état de vigueur différée est renseigné.",
        isDateDebutValid: true,
        isDateFinValid: false,
    },
};
